﻿window.backgroundworker = function () {
    const connections = {};
    const notifications = {};
    const progressbar = {};
    var instance = {
        firstinit: function (sender, form) {
            var args = {
                id: sender.dataset.id,//идентификатор события
                notificationContainer: sender.dataset.notificationcontainer, //место куда рендерить проресс
                action: sender.dataset.action,                //событие которые запускает bw в контроллере
                messageaction: sender.dataset.messageaction,  //алтьтернативный вывод сообщения. вызываем метод контроллера и через него управляем выводом сообщения
                messagemethod: sender.dataset.messagemethod
            };

            this.init(args, sender, form);
        },
        init: function (args, sender, form) {
            const hub = 'backgroundworker';
            const task = args.id.toLowerCase();
            const action = args.action;
            const linkid = args.notificationContainer;
            const messageaction = args.messageaction;
            const messagemethod = args.messagemethod;

            if (action) {
                sender.setAttribute('data-e', action)
            }


            progressbar[task] = { link: linkid, itemsCnt: 0 };

            if (!connections[hub]) {
                const connection = new signalR.HubConnectionBuilder()
                    .withUrl('/' + hub)
                    .configureLogging(signalR.LogLevel.Information)
                    .build();
                connections[hub] = connection;

                connection.on('init', function (taskid, val) {

                    progressbar[taskid].itemsCnt = val;

                });

                connection.on('complete', function (taskid) {
                    //appendLine(notifications[taskid].log, "complete");
                    //decCounter();
                });

                connection.on('progress', function (taskid, val) {
                    const pr = document.getElementById(progressbar[taskid].link);

                    if (val == 0) {
                        pr.append('   ');
                        pr.append('');
                    }

                    const p = Math.round(parseInt(val) / progressbar[taskid].itemsCnt * 100);
                    pr.lastChild.textContent = p + '%';

                });

                connection.on('message', function (taskid, message) {

                    var parms = {
                        message: message,
                        sender: sender,
                        form: form,
                        messageaction: messageaction
                    }

                    window['messageresolver'][messagemethod](parms);
                });

                connection.onclose(function (e) {
                    console.log('connection closed');
                });

                connection.start().then(function () {
                    console.log('connection started');
                    connection.invoke("GetConnectionId").then(function (connid) {
                        sender.setAttribute('data-p-connid', connid);
                        sender.setAttribute('data-p-id', task);

                        return ajaxUtils.formSubmit(sender, form)

                    });
                })
                    .catch(function (error) {
                        console.error(error.message);
                    });
            }
            else {
                connections[hub].invoke("GetConnectionId").then(function (connid) {
                    sender.setAttribute('data-p-connid', connid);
                    sender.setAttribute('data-p-id', task);

                    return ajaxUtils.formSubmit(sender, form)
                });
            }

        },

        runhistorylogger: function (sender) {

            const hub = 'backgroundworker';
            var oid = sender.dataset.oid;
            var returnurl = window.location.href;

            if (!connections[hub]) {

                const connection = new signalR.HubConnectionBuilder()
                    .withUrl('/' + hub)
                    .configureLogging(signalR.LogLevel.Information)
                    .build();
                connections[hub] = connection;

                connection.start().then(function () {
                    console.log('connection started');
                    connection.invoke("GetClientId").then(function (connid) {

                        sender.dataset.href = generateUrl(returnurl, connid, oid);
                        ajaxUtils.runEventFromElementWithApiResponse(sender);

                    });
                })

            }
            else {
                connections[hub].invoke("GetClientId").then(function (connid) {

                    sender.dataset.href = generateUrl(returnurl, connid, oid);
                    ajaxUtils.runEventFromElementWithApiResponse(sender);
                });
            }

            function generateUrl(returnurl, connid, oid) {
                return '/BackgroundWorkerHistoryLog/run?' + '?returnurl=' + returnurl + '&connid=' + connid + '&oid=' + oid;
            }

        }

    };

    function incCounter() {
        const el = document.getElementById('backgroundworker_counter');
        el.innerText = parseInt(el.innerText) + 1;
        el.classList.remove('hide');
    }

    function decCounter() {
        const el = document.getElementById('backgroundworker_counter');
        el.innerText = parseInt(el.innerText) - 1;
        if (el.innerText == 0)
            el.classList.add('hide');
    }

    function appendLine(id, text) {
        const el = document.getElementById(id);
        const div = document.createElement("div");
        div.innerText = text;
        el.appendChild(div);
    }
    return instance;
}();